import React from 'react';
import './SurveyTemplate.scss';

const SurveyTemplate = () => {
    return (
        <div className="survey_template">
           <h3>survey_template</h3>
        </div>
    );
};

export default SurveyTemplate;